export default __webpack_public_path__ + "static/media/squ.8ea05238.svg";